import { useCallback, useState } from 'react';

import { useDebounce } from '@/shared/hooks/useDebounce';

export const useTagCategorySearch = () => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  }, []);

  return {
    query,
    debouncedQuery,
    handleSearch,
  };
};
